import { createContext, useEffect, useState } from "react";
import Cookies from 'universal-cookie';


const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {

    const cookies = new Cookies();
    
    //const refreshToken = cookies.get('refreshToken');
    const privilages = cookies.get('privilages');
    const userStatus = cookies.get('userState');
    const accessToken = cookies.get('accessToken');
    //const loginType = cookies.get('loginType');
    const [auth, setAuth] = useState({accessToken,privilages,userStatus});


    return (
        <AuthContext.Provider value={{ auth, setAuth }}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext;